import { Outlet, Link } from "react-router-dom";
export default function HomePageWallpaper() {
  return (
    <div className="wallpp_main_basket">
      <div className="wallpp_img">
        <img src="./homepage_wallpaper.jpg" />
      </div>

      <div className="call_to_action">
        <div className="call_to_action_inner">
          <h1>Software Development</h1>
          <p>
            We have software solutions that are going to propel your success to
            next level. To learn more please view our services below
          </p>
          <Link to="/services">View Our Services</Link>
        </div>
      </div>
    </div>
  );
}
